import { Button } from "@/components/ui/button";

const CAL_URL = process.env.REACT_APP_CALENDLY_URL;

export default function BookingSection() {
  if (!CAL_URL) return null;

  const openCalendly = () => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "booking_intent", { method: "calendly" });
    }
    window.open(CAL_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <section
      id="rendez-vous"
      data-testid="booking-section"
      className="py-24 md:py-32 bg-spi-blue text-white"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center mb-10">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold">
            Rendez-vous conseil
          </h2>
          <p className="mt-3 text-slate-300 text-sm md:text-base">
            Choisissez votre créneau ci-dessous.
          </p>
        </div>

        <div className="border border-white/10 rounded-2xl overflow-hidden bg-white shadow-2xl mx-auto">
          <iframe
            src={CAL_URL}
            title="Calendrier de prise de rendez-vous"
            className="w-full bg-white block"
            style={{ height: "640px", minHeight: "640px" }}
            loading="lazy"
            data-testid="booking-iframe"
          />
        </div>

        <div className="mt-8 text-center">
          <Button
            onClick={openCalendly}
            data-testid="booking-cta"
            className="bg-spi-red hover:bg-spi-red/90 text-white h-14 px-8 font-bold text-base"
          >
            Bloquer mon rendez-vous conseil
          </Button>
          <p className="mt-3 text-xs text-slate-400">
            Visio ou téléphone, 30 minutes — créneaux disponibles 7 jours/7.
          </p>
        </div>
      </div>
    </section>
  );
}
